import React from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from '../../helpers/classnames';

interface ErrorReportListProps {
  errorReports: ErrorReport[];
  selectedErrorReport?: ErrorReport;
  setSelectedErrorReport: (errorReport: ErrorReport) => void;
  schemaDefinition: EntitySchemaDefinition;
  entityLookup: Record<string, Entity>;
}

const ErrorReportList: React.FC<ErrorReportListProps> = ({
  errorReports,
  setSelectedErrorReport,
  selectedErrorReport,
  schemaDefinition,
  entityLookup,
}) => {
  return (
    <ul className="py-2">
      {errorReports.length === 0 && (
        <li className="text-sm leading-6">
          <FormattedMessage
            id="error_report.no_current_error_reports"
            defaultMessage="No current error reports"
          />
        </li>
      )}
      {errorReports.map((er) => {
        const { property_key, id, entity_id } = er;
        const entity = entityLookup[entity_id];
        const prop = schemaDefinition.propertiesLookup[property_key];
        if (!prop || !entity) {
          return null;
        }
        const group =
          typeof prop.group_id === 'number'
            ? schemaDefinition.groupsLookup[prop.group_id]
            : undefined;
        const name = group ? `${group.name}: ${prop.name}` : prop.name;
        const { stop_letter } = entity;
        return (
          <li key={id}>
            <button
              type="button"
              aria-current={selectedErrorReport === er}
              onClick={() => setSelectedErrorReport(er)}
              className={cn(
                'w-full px-4 py-1 text-left hover:bg-black/5',
                selectedErrorReport === er && 'bg-black/10',
              )}
            >
              <span className="block">{name}</span>
              <span className="block text-sm text-text-800">
                <FormattedMessage
                  id="error_report.stop_x"
                  defaultMessage="Stop {stop_letter}"
                  values={{ stop_letter }}
                />
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ErrorReportList;
